import React from 'react'
import CurrentUser from 'components/CurrentUser'
import { signInUri } from 'utils/unifiedLogin'

const EnsureSession = ({ children, location }) => (
  <CurrentUser
    render={currentUser =>
      currentUser
        ? children
        : window.location.replace(
            signInUri(`${location.pathname}${location.search}`)
          )
    }
  />
)

export default EnsureSession



// WEBPACK FOOTER //
// ./src/components/EnsureSession.js